import React from 'react';
import '../css/PaginaRepresentanteComercial.css';
import { FaMotorcycle } from 'react-icons/fa';
import { FaListAlt, FaUser, FaLock } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

function PaginaRepresentanteComercial() {

  const navigate = useNavigate();

  const cookies = Cookies.get();
  const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

  const handleLogout = () => {
    Cookies.remove('dadosCookies');
    navigate('/conta');
  };

  return (
    <div className="pagina-representante-comercial">
      <h2>Painel do Representante Comercial</h2>
      <h2><strong>{dadosCookies.dadosUsuario.name}</strong></h2>
      <h3>Seja bem-vindo!</h3>


      <div className="opcoes-container">
        <Link to="/cadastrar-ponto-mototaxi" className="opcao-box">
          <FaMotorcycle size={50} style={{ marginBottom: '10px' }} />
          <span>Cadastrar novo Ponto de Mototáxi</span>
        </Link>

        <Link to="/listar-ponto-mototaxi" className="opcao-box">
          <FaListAlt size={50} style={{ marginBottom: '10px' }} />
          <span>Listar Pontos de Mototáxi</span>
        </Link>

        <Link to="/alterar-senha-representante-comercial" className="opcao-box card p-3 text-center shadow-sm flex-fill" >
          <FaLock size={40} className="mb-2 text-primary" />
          <span>Alterar Senha</span>
        </Link>



        {/* <Link to="/meus-dados-cadastrais" className="opcao-box">
          <FaUser size={50} style={{ marginBottom: '10px' }} />
          <span>Meus Dados Cadastrais</span>
        </Link> */}
        
      </div>

      <button onClick={handleLogout} className="btn btn-danger logout-btn">
        Sair
      </button>
    </div>
  );
}

export default PaginaRepresentanteComercial;
